export default "__VITE_ASSET__DRT19v$V__"